import 'https://esm.archive.org/@internetarchive/reviews@1.0.2';
import { RecaptchaManager } from 'https://esm.archive.org/@internetarchive/recaptcha-manager@1.0.0';

// eslint-disable-next-line import/no-named-as-default
import $ from '../util/jquery.js';
import onclick from '../util/onclick.js';

/* Pass Recaptcha Manager to review form when document ready */
document.addEventListener('DOMContentLoaded', () => {
  const reviewForm = document.querySelector('ia-review-form');
  const recaptchaManager = new RecaptchaManager({
    defaultSiteKey: '6Ld64a8UAAAAAGbDwi1927ztGNw7YABQ-dqzvTN2',
  });

  if (reviewForm) {
    reviewForm.recaptchaManager = recaptchaManager;
  }
});

$(() => {
  /* Utility function to display reviews list */
  function displayReviews() {
    $('.details-reviews-list').show();
    $('.display-reviews-msg').hide();
  }

  onclick('.js-reviews-displayReviews', (e) => {
    displayReviews();
  });

  onclick('.js-reviews-addEditReview', (e) => {
    displayReviews();
    $('ia-review-form').attr('displayMode', 'form');
  });

  onclick('.js-reviews-deleteReview', (e) => {
    // eslint-disable-next-line no-alert
    if (confirm('Are you sure you want to delete this review?')) {
      const url = $(e.currentTarget).attr('href');
      if (url) {
        $.ajax({
          type: 'POST',
          url,
        });

        // Replace the review body for the deleted review
        $(e.currentTarget)
          .parent()
          .children('.review-body')
          .html(
            '<span class="deleted-review-msg">This review has been queued for deletion.</span>',
          );
      }
    }
  });

  // Expand selected review
  onclick('.js-reviews-expandReview', (e) => {
    const parentReview = $(e.currentTarget).closest('.aReview');

    parentReview.find('.truncated-msg').hide();
    parentReview.find('.remainder').show();
  });

  // Collapse selected review
  onclick('.js-reviews-collapseReview', (e) => {
    const parentReview = $(e.currentTarget).closest('.aReview');

    parentReview.find('.truncated-msg').show();
    parentReview.find('.remainder').hide();
  });
});
